import { createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../reducers";
import rootSaga from "../sagas";
import {
  localStorageMiddleware,
  reHydrateStore,
  sessionStorageMiddleware,
  reHydrateSessionStore,
} from "./middleware";

const sagaMiddleware = createSagaMiddleware();
export const store = createStore(
  rootReducer,
  reHydrateSessionStore(),
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, sessionStorageMiddleware, logger)
  )
);

sagaMiddleware.run(rootSaga);

export default store;
